var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPacing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 281,
    viewBox: "0 0 371 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4578 182.487V244.429C92.4578 244.958 93.5058 245.487 95.6027 245.888L140.873 276.8C145.066 277.602 151.929 277.602 156.123 276.8L207.881 245.888C209.978 245.487 211.027 244.958 211.027 244.429V182.487H92.4578Z",
    fill: "url(#paint0_linear_9_151555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6027 186.891C93.5058 185.681 92.4578 184.085 92.4578 182.489C92.4571 180.893 93.5058 179.297 95.6027 178.086L144.117 150.076C148.311 147.655 155.173 147.655 159.367 150.077L207.881 178.087C209.978 179.297 211.027 180.893 211.027 182.489C211.027 184.085 209.978 185.681 207.881 186.891L159.367 214.901C155.173 217.322 148.311 217.322 144.117 214.901L95.6027 186.891Z",
    fill: "#F6F6FB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.223 205.73L100.175 203.97V200.449L103.223 202.209V205.73Z",
    fill: "#F6F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.37 211.012L109.321 209.252V205.731L112.37 207.492V211.012Z",
    fill: "#CED3F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.516 216.29L118.467 214.529V211.009L121.516 212.769V216.29ZM130.662 221.57L127.613 219.81V216.29L130.662 218.05V221.57ZM139.809 226.851L136.76 225.091V221.57L139.809 223.33V226.851ZM103.223 216.53L100.175 214.769V211.249L103.223 213.009V216.53ZM112.37 221.81L109.321 220.05V216.53L112.37 218.29V221.81ZM121.516 227.091L118.467 225.331V221.81L121.516 223.571V227.091ZM130.662 232.372L127.613 230.611V227.091L130.662 228.851V232.372ZM139.809 237.653L136.76 235.892V232.372L139.809 234.132V237.653ZM103.223 227.331L100.175 225.571V222.051L103.223 223.811V227.331ZM112.37 232.612L109.321 230.852V227.331L112.37 229.091V232.612ZM121.516 237.893L118.467 236.132V232.612L121.516 234.372V237.893Z",
    fill: "#F6F6FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.663 243.174L127.615 241.414V237.894L130.663 239.654V243.174Z",
    fill: "#CED3F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.809 248.455L136.76 246.695V243.175L139.809 244.935V248.455ZM103.223 238.134L100.175 236.374V232.854L103.223 234.614V238.134ZM112.37 243.415L109.321 241.655V238.134L112.37 239.895V243.415ZM121.516 248.696L118.467 246.935V243.415L121.516 245.175V248.696ZM130.662 253.976L127.613 252.216V248.696L130.662 250.456V253.976ZM139.809 259.257L136.76 257.497V253.976L139.809 255.737V259.257ZM103.223 248.936L100.175 247.175V243.655L103.223 245.415V248.936Z",
    fill: "#F6F6FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.37 254.218L109.321 252.458V248.938L112.37 250.698V254.218Z",
    fill: "#CED3F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.81 280.856L136.761 279.096V275.575L139.81 277.335V280.856Z",
    fill: "#F6F6FB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.37 275.816L109.321 274.056V270.535L112.37 272.295V275.816Z",
    fill: "#F6F6FB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.259 205.73L203.308 203.97V200.449L200.259 202.209V205.73Z",
    fill: "#CED3F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191.112 211.012L194.161 209.252V205.731L191.112 207.492V211.012ZM181.966 216.293L185.015 214.532V211.012L181.966 212.772V216.293Z",
    fill: "#F6F6FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.819 221.571L175.868 219.811V216.29L172.819 218.05V221.571Z",
    fill: "#CED3F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 226.853L166.722 225.092V221.572L163.673 223.332V226.853ZM200.259 216.531L203.307 214.771V211.251L200.259 213.011V216.531Z",
    fill: "#F6F6FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.113 221.814L194.161 220.054V216.533L191.113 218.293V221.814Z",
    fill: "#CED3F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.966 227.09L185.015 225.33V221.81L181.966 223.57V227.09ZM172.819 232.371L175.868 230.611V227.09L172.819 228.85V232.371ZM163.673 237.652L166.722 235.891V232.371L163.673 234.131V237.652ZM200.259 227.33L203.307 225.57V222.05L200.259 223.81V227.33ZM191.112 232.611L194.161 230.851V227.33L191.112 229.09V232.611ZM181.966 237.892L185.015 236.131V232.611L181.966 234.371V237.892ZM172.819 243.172L175.868 241.412V237.892L172.819 239.652V243.172ZM163.673 248.453L166.722 246.693V243.172L163.673 244.932V248.453ZM200.259 238.132L203.307 236.372V232.851L200.259 234.611V238.132ZM191.112 243.412L194.161 241.652V238.132L191.112 239.892V243.412ZM181.966 248.693L185.015 246.933V243.412L181.966 245.173V248.693Z",
    fill: "#F6F6FB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.819 253.976L175.868 252.216V248.695L172.819 250.456V253.976Z",
    fill: "#CED3F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.673 259.257L166.722 257.497V253.977L163.673 255.737V259.257Z",
    fill: "#F6F6FB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.259 248.936L203.308 247.175V243.655L200.259 245.415V248.936Z",
    fill: "#CED3F8"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.797 65.8157C234.797 62.3906 232.37 58.1876 229.403 56.4752L148.041 9.50103C145.076 7.78935 142.649 9.18962 142.649 12.6151V83.4361C142.649 86.8615 145.076 91.0641 148.041 92.7768L229.403 139.751C232.369 141.464 234.796 140.062 234.796 136.638L234.797 65.8157Z",
    fill: "url(#paint1_linear_9_151555)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M224.474 136.909C224.474 136.893 224.476 136.878 224.476 136.862V98.5279C222.166 92.3104 218.614 80.9593 215.546 79.1881C210.089 76.0371 205.588 99.4469 199.787 96.0966C194.221 92.8832 194.319 77.454 188.636 74.1726C184.393 71.7228 183.801 78.7738 179.538 76.312C174.209 73.2362 172.316 55.6212 167.579 52.8869C163.079 50.2886 162.369 58.3313 159.29 56.554C154.909 54.0244 157.395 43.1145 151.636 39.7891V94.8067C151.636 94.8233 151.638 94.8407 151.638 94.8574L224.474 136.909Z",
    fill: "url(#paint2_linear_9_151555)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234.798 136.638V65.8157C234.798 62.3902 232.371 58.1873 229.405 56.4749L148.042 9.50103C146.578 8.65548 145.245 8.57177 144.27 9.11442L146.194 8.00358L146.197 8.00961C147.182 7.37793 148.569 7.42332 150.106 8.31002L231.467 55.2842C234.433 56.9973 236.86 61.1995 236.86 64.625V135.446C236.86 137.239 236.192 138.469 235.134 138.997L233.343 140.031C234.241 139.436 234.798 138.27 234.798 136.638L234.798 136.638Z",
    fill: "url(#paint3_linear_9_151555)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.192 63.0212C176.192 61.3666 177.354 60.6959 178.787 61.5234C179.542 62.0158 180.171 62.6793 180.622 63.4601C181.073 64.2409 181.333 65.1169 181.382 66.0172C181.382 67.6721 180.22 68.3428 178.787 67.5153C178.032 67.023 177.403 66.3595 176.952 65.5787C176.502 64.7979 176.241 63.9218 176.192 63.0216V63.0212Z",
    fill: "#807DFB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.99 40.4285L153.133 33.5829V19.8916L164.99 26.7372V40.4285ZM185.024 51.8789L173.168 45.0333V31.342L185.024 38.1876V51.8789Z",
    fill: "#BBC0E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M205.059 63.325L193.202 56.4793V42.7881L205.059 49.6337V63.325Z",
    fill: "#FCBA06"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.094 74.7762L213.237 67.9305V54.2393L225.094 61.0849V74.7762Z",
    fill: "#BBC0E6"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.122 129.531L213.795 128.764V123.412L215.122 124.179V129.531ZM207.446 125.147L206.118 124.381V119.028L207.446 119.795V125.147ZM199.769 120.763L198.442 119.997V114.645L199.769 115.411V120.763ZM192.092 116.379L190.765 115.613V110.261L192.092 111.027V116.379ZM184.416 111.996L183.088 111.229V105.877L184.416 106.643V111.996ZM176.739 107.612L175.411 106.845V101.493L176.739 102.26V107.612ZM169.062 103.228L167.735 102.461V97.1094L169.062 97.8759V103.228ZM161.385 98.8441L160.058 98.0777V92.7256L161.385 93.492V98.8441Z",
    fill: "#807DFB"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M149.918 187.557H189.722V194.871H149.918V187.557Z",
    fill: "url(#paint4_linear_9_151555)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M131.971 176.993H171.775V184.308H131.971V176.993Z",
    fill: "url(#paint5_linear_9_151555)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.566 182.06C127.566 176.312 131.209 176.146 131.209 176.146C131.209 176.146 133.181 176.146 136.385 174.816C139.546 173.502 144.002 174.011 141.512 178.604C141.488 178.662 141.459 178.719 141.426 178.773C141.219 179.071 140.941 179.314 140.618 179.481L132.661 184.15C131.447 184.843 127.595 183.242 127.566 182.06Z",
    fill: "url(#paint6_linear_9_151555)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.587 181.539C127.656 182.72 131.457 184.289 132.661 183.603L140.618 178.935C141.017 178.698 141.393 178.424 141.741 178.117C141.667 178.276 141.603 178.426 141.512 178.599C141.488 178.658 141.459 178.714 141.426 178.768C141.218 179.066 140.941 179.309 140.618 179.476L132.661 184.145C131.525 184.793 128.072 183.431 127.617 182.282C127.598 182.206 127.586 182.128 127.582 182.049C127.572 181.879 127.574 181.709 127.587 181.539Z",
    fill: "#1E1C6B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.047 175.389C129.985 175.389 133.286 176.228 133.286 176.228C133.313 176.532 133.414 176.826 133.581 177.082C133.614 177.119 133.643 177.156 133.673 177.194C134.325 177.647 134.988 178.363 133.442 179.333C132.177 180.129 131.148 179.624 130.659 179.135C130.459 178.721 130.149 178.369 129.763 178.118C129.503 177.939 129.21 177.815 128.901 177.754C128.901 177.728 128.898 177.701 128.893 177.675C128.893 177.675 128.654 175.389 129.047 175.389Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.989 119.196C132.588 119.259 141.582 119.419 145.178 119.485C143.839 130.302 141.146 140.125 139.345 150.6C137.414 160.782 135.237 167.935 133.337 176.407C132.642 177.985 129.46 177.389 128.814 175.871C128.31 168.068 127.732 158.561 130.045 149.559C129.658 139.855 128.763 128.992 128.989 119.195V119.196Z",
    fill: "url(#paint7_linear_9_151555)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M145.707 192.618C145.707 186.871 149.35 186.705 149.35 186.705C149.35 186.705 151.322 186.705 154.527 185.376C157.686 184.062 162.143 184.569 159.652 189.163C159.628 189.222 159.6 189.279 159.567 189.333C159.359 189.631 159.082 189.874 158.759 190.04L150.801 194.71C149.589 195.403 145.736 193.8 145.707 192.618V192.618Z",
    fill: "url(#paint8_linear_9_151555)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M145.729 192.101C145.798 193.282 149.599 194.852 150.801 194.165L158.759 189.498C159.158 189.262 159.534 188.988 159.882 188.681C159.807 188.839 159.744 188.99 159.652 189.162C159.628 189.221 159.599 189.278 159.567 189.332C159.359 189.63 159.082 189.873 158.759 190.039L150.801 194.708C149.667 195.357 146.213 193.994 145.757 192.846C145.738 192.769 145.726 192.691 145.722 192.613C145.713 192.442 145.715 192.271 145.729 192.101Z",
    fill: "#1E1C6B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.191 185.943C148.127 185.943 151.43 186.782 151.43 186.782C151.456 187.087 151.557 187.381 151.724 187.638C151.757 187.675 151.785 187.711 151.816 187.75C152.468 188.203 153.131 188.919 151.585 189.889C150.319 190.684 149.292 190.179 148.803 189.692C148.601 189.277 148.291 188.925 147.904 188.673C147.646 188.495 147.353 188.371 147.045 188.309C147.044 188.283 147.041 188.257 147.036 188.231C147.036 188.231 146.797 185.943 147.191 185.943Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.409 144.914C139.423 140.264 128.077 139.687 128.822 121.404C132.383 120.88 150.343 129.303 153.902 128.78C154.346 139.67 153.295 149.802 153.227 160.43C152.986 170.789 152.006 178.201 151.515 186.873C151.087 188.542 147.85 188.472 146.966 187.082C145.195 179.466 143.071 170.18 143.884 160.923C142.822 155.794 141.561 150.358 140.409 144.914Z",
    fill: "url(#paint9_linear_9_151555)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M137.031 85.8994C124.361 94.3649 122.851 111.177 129.701 121.847C129.701 121.847 128.229 98.2067 137.031 85.8994Z",
    fill: "url(#paint10_linear_9_151555)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M171.947 73.3047C169.562 78.3457 166.078 85.6436 164.731 87.0967C163.067 88.8928 160.064 89.7178 156.788 90.8463C154.825 91.5224 152.945 91.0928 150.977 90.2462C150.245 89.903 149.565 89.4562 148.959 88.9194C146.476 86.6526 144.799 84.4973 143.521 84.2362C132.976 82.0837 127.852 100.875 128.734 120.908C129.548 126.236 132.656 129.637 136.453 131.768C144.165 136.095 152.233 136.104 154.984 130.783C153.955 120.877 152.999 112.114 154.984 102.62L154.982 102.604C163.638 100.11 169.483 93.6125 170.404 91.5724C172.637 86.6282 174.248 81.059 176.152 75.1636L171.947 73.3047Z",
    fill: "url(#paint11_linear_9_151555)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.673 85.4354C139.96 83.7826 139.622 82.7008 139.279 80.4511C138.821 79.2076 138.588 77.8926 138.59 76.5674C138.59 71.5579 141.78 67.2287 145.691 67.4972C153.571 68.0381 152.169 72.185 152.169 77.1955C152.169 81.8365 150.064 85.0314 146.543 85.5695C146.543 86.3306 146.745 86.7683 147.704 87.7273C145.131 89.2698 141.373 88.5438 139.888 87.8727C138.307 87.1584 136.6 86.5452 137.673 85.4354Z",
    fill: "#FACFA7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.227 66.2249C143.243 65.7024 144.158 65.9723 144.725 65.6091C146.07 64.7859 147.345 64.2603 148.058 64.6515C148.413 64.8886 148.748 65.1551 149.059 65.4481C149.761 66.1486 151.197 64.6572 151.542 66.4664C151.63 66.9299 151.67 67.4013 151.661 67.873C155.026 68.3054 153.369 71.3702 150.665 77.2734C150.662 76.3147 148.627 74.1001 148.627 78.3584C148.627 78.8159 148.968 78.9046 148.668 79.5121C148.366 80.1179 146.433 81.6448 145.156 82.9202C143.377 84.7007 142.331 83.1036 139.389 83.4242C139.408 82.4719 139.138 81.536 138.614 80.7407C138.331 80.2424 136.716 78.6577 136.715 75.8923C138.999 76.1732 134.938 69.9805 142.227 66.2249Z",
    fill: "#131147"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.807 72.3118L172.794 72.3483C172.794 70.6877 173.142 69.7202 173.782 69.4364C173.92 69.0395 174.066 68.6256 174.207 68.2305C175.034 65.9123 177.629 63.9254 178.18 64.4766C178.513 64.81 177.193 65.8293 176.497 66.9331C176.169 67.4588 175.971 68.0542 175.917 68.671C175.917 68.671 179.022 68.9615 179.022 71.5411C179.022 73.639 177.89 72.8098 177.89 72.3969C177.089 74.5211 176.138 73.2652 175.769 74.9963L172.41 73.5113C172.41 73.5113 172.567 73.0311 172.807 72.3118Z",
    fill: "#FCD1A9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1316 189.018C41.1316 199.36 48.3936 211.938 57.3521 217.11C66.3063 222.28 73.5679 218.089 73.5679 207.746C73.5679 197.404 66.3063 184.826 57.3521 179.654C48.3936 174.483 41.1316 178.677 41.1316 189.018Z",
    stroke: "#FFF294",
    strokeWidth: 0.709355,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6177 195.667C29.6177 206.008 36.8793 218.587 45.8378 223.758C54.792 228.928 62.0536 224.737 62.0536 214.395C62.0536 204.052 54.792 191.474 45.8378 186.303C36.8793 181.131 29.6177 185.325 29.6177 195.667V195.667Z",
    stroke: "#FFE54C",
    strokeWidth: 1.06403,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0992 202.315C18.0992 212.657 25.3609 225.235 34.3193 230.407C43.2735 235.577 50.5352 231.385 50.5352 221.043C50.5352 210.701 43.2735 198.123 34.3193 192.952C25.3609 187.779 18.0989 191.974 18.0989 202.315L18.0992 202.315Z",
    stroke: "#FFE950",
    strokeWidth: 1.41871,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9366 228.303C30.9366 220.203 25.2475 210.348 18.232 206.296C11.2144 202.246 5.52393 205.53 5.52393 213.633C5.52393 221.737 11.2144 231.59 18.2306 235.641C25.2475 239.691 30.9362 236.408 30.9362 228.303L30.9366 228.303Z",
    fill: "#FFD03E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0.92749 212.235C0.92749 222.577 8.18916 235.155 17.1476 240.327C26.1018 245.496 33.3635 241.306 33.3635 230.963C33.3635 220.621 26.1018 208.043 17.1476 202.871C8.18916 197.699 0.92749 201.893 0.92749 212.235ZM4.44022 214.264C4.44022 206.16 10.1271 202.876 17.1476 206.927C24.1631 210.978 29.85 220.831 29.85 228.935C29.85 237.037 24.1621 240.323 17.1476 236.27C10.1271 232.22 4.44022 222.366 4.44022 214.264Z",
    fill: "#FFE54C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72341 205.754C6.7326 207.195 5.52315 209.903 5.52315 213.636C5.52315 221.74 11.2136 231.593 18.2298 235.644C21.462 237.51 24.4108 237.816 26.652 236.816C24.3243 238.502 20.9303 238.454 17.1481 236.268C10.1276 232.219 4.44067 222.364 4.44067 214.262C4.44067 209.891 6.09737 206.925 8.72341 205.754Z",
    fill: "url(#paint12_linear_9_151555)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 198.621C14.0372 196.759 18.1954 196.935 22.8048 199.597C31.7618 204.768 39.0217 217.345 39.0217 227.689C39.0217 232.935 37.1515 236.595 34.1421 238.257H34.1446L28.9773 241.222C31.698 239.444 33.365 235.906 33.365 230.956C33.365 220.613 26.1033 208.035 17.1491 202.864C12.7656 200.333 8.7922 200.051 5.87036 201.626L11.0834 198.617V198.621Z",
    fill: "url(#paint13_linear_9_151555)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.057 211.867V211.118C15.6206 211.136 15.198 211.276 14.8365 211.521L14.8482 211.49L13.803 212.088L13.8193 212.104C14.1517 211.902 14.5247 211.776 14.9117 211.735C15.2986 211.693 15.6899 211.739 16.0573 211.867H16.057Z",
    fill: "#E19100"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2339 219.795C17.5338 219.339 16.9511 218.724 16.533 218C16.1149 217.276 15.8732 216.464 15.8274 215.629C15.8174 215.253 15.9061 214.881 16.0849 214.55C15.2929 214.547 14.7425 215.165 14.7432 216.255C14.7882 217.09 15.0297 217.902 15.448 218.626C15.8663 219.35 16.4496 219.965 17.1504 220.421C19.6799 221.882 21.7392 225.449 21.7392 228.372C21.7392 229.921 21.1596 230.979 20.2378 231.413L21.4228 230.737V230.721C22.2811 230.255 22.8248 229.232 22.8248 227.745C22.8248 224.823 20.7631 221.256 18.2339 219.795Z",
    fill: "url(#paint14_linear_9_151555)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2395 233.326L19.3248 232.699V231.613C18.9587 231.636 18.5914 231.594 18.2395 231.49V233.326Z",
    fill: "#E19100"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1399 209.253L16.0564 209.88L18.2384 211.14L19.3237 210.512L17.1399 209.253Z",
    fill: "#FCBA06"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3255 210.513L18.2402 211.14L18.2395 213.128L19.3248 212.5L19.3255 210.513Z",
    fill: "#E19100"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3248 212.504L18.2395 213.131C20.2452 214.856 21.7388 217.806 21.7398 220.294L22.8255 219.668C22.8219 217.18 21.3305 214.229 19.3248 212.504Z",
    fill: "url(#paint15_linear_9_151555)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6443 222.443L12.5601 223.07L14.7431 224.33L15.8273 223.703L13.6443 222.443Z",
    fill: "#FCBA06"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2339 227.871C17.5335 227.414 16.9506 226.799 16.5325 226.075C16.1144 225.351 15.8728 224.538 15.8274 223.703L14.7432 224.33C14.789 225.165 15.0308 225.978 15.449 226.702C15.8672 227.426 16.45 228.042 17.1504 228.499C18.0931 229.043 18.9039 228.875 19.2969 228.187C18.9208 228.178 18.5539 228.069 18.2339 227.871Z",
    fill: "url(#paint16_linear_9_151555)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1503 220.421C16.4495 219.965 15.8662 219.35 15.448 218.626C15.0297 217.902 14.7882 217.089 14.7431 216.255C14.7424 214.72 15.8224 214.099 17.1503 214.864C17.8503 215.322 18.4329 215.937 18.8508 216.661C19.2688 217.386 19.5104 218.198 19.5561 219.033L21.7391 220.293C21.7381 217.806 20.2445 214.856 18.2388 213.131L18.2395 211.143L16.0575 209.883V211.869C14.0536 211.281 12.5604 212.505 12.5604 214.995C12.6466 216.587 13.1072 218.137 13.9047 219.518C14.7022 220.899 15.8142 222.072 17.1503 222.942C17.8504 223.399 18.4331 224.015 18.851 224.739C19.269 225.463 19.5105 226.275 19.5561 227.11C19.5561 228.642 18.4768 229.266 17.1503 228.501C16.4499 228.043 15.867 227.428 15.4488 226.704C15.0306 225.979 14.7889 225.167 14.7431 224.332L12.5601 223.072C12.5601 225.556 14.0533 228.507 16.0575 230.232V232.067L18.2395 233.327V231.492C20.2445 232.082 21.7391 230.858 21.7391 228.371C21.7391 225.449 19.6799 221.882 17.1503 220.421Z",
    fill: "#FFE54C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M278.28 12.0789C278.28 22.4206 285.542 34.9988 294.501 40.1704C303.455 45.3402 310.717 41.1493 310.717 30.8069C310.717 20.4645 303.455 7.88658 294.501 2.71503C285.542 -2.45688 278.28 1.73718 278.28 12.0789Z",
    stroke: "#FFF294",
    strokeWidth: 0.709355,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M266.766 18.7275C266.766 29.0689 274.028 41.6475 282.986 46.8187C291.941 51.9885 299.202 47.7976 299.202 37.4552C299.202 27.1128 291.941 14.5349 282.986 9.36369C274.028 4.19143 266.766 8.3855 266.766 18.7272V18.7275Z",
    stroke: "#FFE54C",
    strokeWidth: 1.06403,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M255.248 25.3759C255.248 35.7176 262.51 48.2959 271.468 53.4671C280.422 58.6372 287.684 54.446 287.684 44.1036C287.684 33.7612 280.422 21.1833 271.468 16.0121C262.51 10.8398 255.248 15.0342 255.248 25.3756L255.248 25.3759Z",
    stroke: "#FFE950",
    strokeWidth: 1.41871,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M268.085 51.3637C268.085 43.2632 262.396 33.4085 255.381 29.3563C248.363 25.3066 242.673 28.5909 242.673 36.6939C242.673 44.7972 248.363 54.6501 255.379 58.7016C262.396 62.752 268.085 59.4684 268.085 51.3633L268.085 51.3637Z",
    fill: "#FFD03E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M238.076 35.2957C238.076 45.6374 245.338 58.2156 254.296 63.3872C263.25 68.557 270.512 64.3661 270.512 54.0237C270.512 43.6813 263.25 31.1034 254.296 25.9318C245.338 20.7599 238.076 24.954 238.076 35.2957ZM241.589 37.3244C241.589 29.2207 247.276 25.9368 254.296 29.9872C261.312 34.039 266.999 43.892 266.999 51.996C266.999 60.0979 261.311 63.3837 254.296 59.3307C247.276 55.2807 241.589 45.4263 241.589 37.3244Z",
    fill: "#FFE54C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M245.872 28.8145C243.881 30.2559 242.672 32.9631 242.672 36.6968C242.672 44.8001 248.362 54.6531 255.379 58.7046C258.611 60.5702 261.559 60.8766 263.801 59.8761C261.473 61.5626 258.079 61.5147 254.297 59.3288C247.276 55.2791 241.589 45.4247 241.589 37.3228C241.589 32.9511 243.246 29.9856 245.872 28.8145Z",
    fill: "url(#paint17_linear_9_151555)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M248.232 21.6812C251.186 19.8195 255.344 19.9954 259.953 22.6576C268.911 27.8288 276.17 40.4053 276.17 50.7492C276.17 55.9955 274.3 59.6558 271.291 61.3178H271.293L266.126 64.2822C268.847 62.5046 270.514 58.9663 270.514 54.0161C270.514 43.6737 263.252 31.0958 254.298 25.9242C249.914 23.3932 245.941 23.1116 243.019 24.6867L248.232 21.678V21.6812Z",
    fill: "url(#paint18_linear_9_151555)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M253.206 34.9271V34.1787C252.769 34.1969 252.347 34.3363 251.985 34.5813L251.997 34.5504L250.952 35.1484L250.968 35.1647C251.3 34.9624 251.673 34.8362 252.06 34.7951C252.447 34.754 252.839 34.7991 253.206 34.9271H253.206Z",
    fill: "#E19100"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M255.383 42.856C254.682 42.3993 254.1 41.7842 253.682 41.0603C253.264 40.3365 253.022 39.5243 252.976 38.6896C252.966 38.3135 253.055 37.9414 253.234 37.6104C252.442 37.6079 251.891 38.2257 251.892 39.3156C251.937 40.1505 252.178 40.963 252.597 41.687C253.015 42.411 253.598 43.026 254.299 43.482C256.829 44.9426 258.888 48.5096 258.888 51.4321C258.888 52.9814 258.308 54.0394 257.387 54.4738L258.571 53.7971V53.7819C259.43 53.3151 259.974 52.2929 259.974 50.8058C259.974 47.8832 257.912 44.3162 255.383 42.856Z",
    fill: "url(#paint19_linear_9_151555)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M255.388 56.3862L256.473 55.7592V54.6735C256.107 54.6961 255.74 54.6546 255.388 54.5508V56.3862Z",
    fill: "#E19100"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M254.289 32.3135L253.205 32.9402L255.387 34.2004L256.472 33.5729L254.289 32.3135Z",
    fill: "#FCBA06"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M256.474 33.5732L255.389 34.2007L255.388 36.1883L256.473 35.5608L256.474 33.5732Z",
    fill: "#E19100"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M256.473 35.5645L255.388 36.1919C257.394 37.917 258.887 40.8665 258.888 43.3546L259.974 42.7283C259.971 40.2409 258.479 37.29 256.473 35.5645Z",
    fill: "url(#paint20_linear_9_151555)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M250.793 45.5039L249.709 46.131L251.892 47.3908L252.976 46.7637L250.793 45.5039Z",
    fill: "#FCBA06"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M255.383 50.9318C254.682 50.475 254.099 49.8596 253.681 49.1354C253.263 48.4112 253.021 47.5987 252.976 46.7637L251.892 47.3907C251.938 48.2258 252.179 49.0383 252.598 49.7625C253.016 50.4867 253.599 51.1022 254.299 51.5593C255.242 52.1037 256.053 51.9359 256.446 51.2479C256.069 51.2387 255.703 51.1296 255.383 50.9318Z",
    fill: "url(#paint21_linear_9_151555)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M254.299 43.4815C253.598 43.0255 253.015 42.4104 252.597 41.6865C252.178 40.9625 251.937 40.15 251.892 39.3151C251.891 37.7808 252.971 37.1598 254.299 37.9248C254.999 38.3821 255.582 38.9977 255.999 39.7219C256.417 40.4461 256.659 41.2584 256.705 42.0933L258.888 43.3539C258.887 40.8661 257.393 37.9163 255.387 36.1911L255.388 34.2035L253.206 32.9434V34.9295C251.202 34.3415 249.709 35.5658 249.709 38.0553C249.795 39.6477 250.256 41.1972 251.053 42.5781C251.851 43.9591 252.963 45.1324 254.299 46.0029C254.999 46.4599 255.582 47.0754 256 47.7995C256.418 48.5236 256.659 49.3359 256.705 50.1707C256.705 51.703 255.625 52.3268 254.299 51.5611C253.599 51.104 253.016 50.4884 252.598 49.7641C252.179 49.0399 251.938 48.2273 251.892 47.3922L249.709 46.1324C249.709 48.6169 251.202 51.5678 253.206 53.2926V55.1274L255.388 56.3879V54.5524C257.393 55.1426 258.888 53.9186 258.888 51.4316C258.888 48.5091 256.829 44.9421 254.299 43.4815Z",
    fill: "#FFE54C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.426 28.3893C86.426 35.6267 91.5082 44.4293 97.7775 48.0484C104.044 51.6664 109.126 48.7335 109.126 41.4956C109.126 34.2578 104.044 25.4554 97.7775 21.8363C91.5082 18.2168 86.426 21.1519 86.426 28.3893Z",
    stroke: "#FFF294",
    strokeWidth: 0.496424,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M78.365 33.0418C78.365 40.2789 83.4469 49.0818 89.7162 52.7007C95.9826 56.3186 101.064 53.3857 101.064 46.1479C101.064 38.91 95.9826 30.1077 89.7162 26.4888C83.4469 22.8691 78.365 25.8042 78.365 33.0416V33.0418Z",
    stroke: "#FFE54C",
    strokeWidth: 0.744636,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3088 37.6931C70.3088 44.9305 75.3907 53.7331 81.6601 57.352C87.9264 60.9702 93.0083 58.0371 93.0083 50.7992C93.0083 43.5614 87.9264 34.759 81.6601 31.1401C75.3907 27.5204 70.3086 30.4558 70.3086 37.6929L70.3088 37.6931Z",
    stroke: "#FFE950",
    strokeWidth: 0.992848,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2905 55.8825C79.2905 50.2136 75.3092 43.3171 70.3995 40.4812C65.4884 37.6471 61.5061 39.9456 61.5061 45.6162C61.5061 51.2871 65.4884 58.1825 70.3985 61.0178C75.3092 63.8524 79.2902 61.5544 79.2902 55.8823L79.2905 55.8825Z",
    fill: "#FFD03E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2908 44.6325C58.2908 51.8698 63.3727 60.6724 69.642 64.2916C75.9084 67.9095 80.9902 64.9767 80.9902 57.7388C80.9902 50.5009 75.9084 41.6986 69.642 38.0794C63.3727 34.46 58.2908 37.3951 58.2908 44.6325ZM60.7491 46.0522C60.7491 40.3811 64.7289 38.0829 69.642 40.9175C74.5516 43.753 78.5315 50.6484 78.5315 56.3198C78.5315 61.9897 74.5509 64.2891 69.642 61.4528C64.7289 58.6185 60.7491 51.7221 60.7491 46.0522Z",
    fill: "#FFE54C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7472 40.1006C62.3539 41.1093 61.5075 43.0039 61.5075 45.6168C61.5075 51.2877 65.4899 58.1831 70.4 61.0184C72.6619 62.324 74.7256 62.5384 76.294 61.8382C74.665 63.0185 72.2899 62.985 69.6429 61.4552C64.7298 58.6212 60.75 51.7248 60.75 46.0549C60.75 42.9955 61.9094 40.9202 63.7472 40.1006Z",
    fill: "url(#paint22_linear_9_151555)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3989 35.112C67.4661 33.8091 70.3761 33.9322 73.6019 35.7953C79.8702 39.4142 84.9508 48.2156 84.9508 55.4544C84.9508 59.126 83.642 61.6875 81.5359 62.8506H81.5377L77.9215 64.9252C79.8255 63.6812 80.9921 61.205 80.9921 57.7407C80.9921 50.5028 75.9102 41.7005 69.6439 38.0813C66.5762 36.3101 63.7955 36.113 61.7507 37.2153L65.3989 35.1097V35.112Z",
    fill: "url(#paint23_linear_9_151555)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8791 44.3802V43.8564C68.5738 43.8692 68.278 43.9667 68.025 44.1382L68.0332 44.1166L67.3018 44.5351L67.3132 44.5465C67.5458 44.4049 67.8069 44.3166 68.0776 44.2878C68.3484 44.259 68.6222 44.2906 68.8794 44.3802H68.8791Z",
    fill: "#E19100"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4036 49.9259C69.9136 49.6063 69.5058 49.1758 69.2132 48.6692C68.9207 48.1627 68.7515 47.5943 68.7195 47.0102C68.7124 46.747 68.7746 46.4866 68.8997 46.2549C68.3454 46.2532 67.9602 46.6855 67.9607 47.4483C67.9922 48.0326 68.1613 48.6012 68.454 49.1078C68.7467 49.6145 69.1549 50.0449 69.6453 50.364C71.4156 51.3862 72.8567 53.8824 72.8567 55.9277C72.8567 57.0119 72.4511 57.7523 71.806 58.0564L72.6353 57.5828V57.5721C73.2359 57.2455 73.6164 56.5301 73.6164 55.4894C73.6164 53.4441 72.1736 50.9478 70.4036 49.9259Z",
    fill: "url(#paint24_linear_9_151555)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M70.408 59.3978L71.1675 58.9589V58.1992C70.9112 58.215 70.6542 58.1859 70.408 58.1133V59.3978Z",
    fill: "#E19100"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.635 42.5479L68.8767 42.9864L70.4037 43.8683L71.1632 43.4293L69.635 42.5479Z",
    fill: "#FCBA06"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.168 43.4297L70.4085 43.8688L70.408 45.2598L71.1675 44.8207L71.168 43.4297Z",
    fill: "#E19100"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1675 44.8262L70.408 45.2653C71.8116 46.4726 72.8568 48.5367 72.8576 50.2779L73.6173 49.8396C73.6149 48.0989 72.5711 46.0337 71.1675 44.8262Z",
    fill: "url(#paint25_linear_9_151555)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1907 51.7793L66.4319 52.2181L67.9596 53.0998L68.7184 52.6609L67.1907 51.7793Z",
    fill: "#FCBA06"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4036 55.5781C69.9134 55.2584 69.5055 54.8277 69.2129 54.3209C68.9203 53.8141 68.7512 53.2455 68.7195 52.6611L67.9607 53.1C67.9928 53.6843 68.162 54.2529 68.4546 54.7598C68.7473 55.2666 69.1552 55.6973 69.6453 56.0172C70.3051 56.3982 70.8725 56.2808 71.1475 55.7993C70.8843 55.7929 70.6275 55.7165 70.4036 55.5781Z",
    fill: "url(#paint26_linear_9_151555)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6442 50.3641C69.1538 50.045 68.7456 49.6146 68.4529 49.1079C68.1602 48.6012 67.9912 48.0327 67.9596 47.4484C67.9591 46.3746 68.7149 45.94 69.6442 46.4754C70.1341 46.7954 70.5418 47.2262 70.8343 47.733C71.1268 48.2398 71.2959 48.8084 71.3279 49.3926L72.8556 50.2748C72.8549 48.5338 71.8096 46.4694 70.406 45.2621L70.4065 43.8711L68.8795 42.9893V44.3792C67.4771 43.9677 66.4321 44.8245 66.4321 46.5667C66.4925 47.6811 66.8148 48.7655 67.3729 49.7319C67.931 50.6983 68.7092 51.5195 69.6442 52.1287C70.1342 52.4485 70.542 52.8792 70.8345 53.3859C71.127 53.8927 71.296 54.4612 71.3279 55.0454C71.3279 56.1177 70.5726 56.5543 69.6442 56.0184C69.1541 55.6985 68.7462 55.2677 68.4535 54.7608C68.1609 54.254 67.9917 53.6853 67.9596 53.1009L66.4319 52.2193C66.4319 53.958 67.4769 56.0231 68.8795 57.2302V58.5142L70.4065 59.3963V58.1118C71.8096 58.5248 72.8556 57.6682 72.8556 55.9278C72.8556 53.8825 71.4145 51.3863 69.6442 50.3641Z",
    fill: "#FFE54C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M348.021 160.561C348.021 167.799 353.103 176.601 359.372 180.22C365.638 183.838 370.72 180.905 370.72 173.668C370.72 166.43 365.638 157.627 359.372 154.008C353.103 150.389 348.021 153.324 348.021 160.561Z",
    stroke: "#FFF294",
    strokeWidth: 0.496424,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M339.959 165.214C339.959 172.451 345.041 181.254 351.311 184.873C357.577 188.49 362.659 185.558 362.659 178.32C362.659 171.082 357.577 162.28 351.311 158.661C345.041 155.041 339.959 157.976 339.959 165.213V165.214Z",
    stroke: "#FFE54C",
    strokeWidth: 0.744636,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 169.865C331.903 177.102 336.985 185.905 343.255 189.524C349.521 193.142 354.603 190.209 354.603 182.971C354.603 175.733 349.521 166.931 343.255 163.312C336.985 159.692 331.903 162.628 331.903 169.865L331.903 169.865Z",
    stroke: "#FFE950",
    strokeWidth: 0.992848,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M340.885 188.054C340.885 182.385 336.904 175.489 331.994 172.653C327.083 169.819 323.101 172.117 323.101 177.788C323.101 183.459 327.083 190.354 331.993 193.19C336.904 196.024 340.885 193.726 340.885 188.054L340.885 188.054Z",
    fill: "#FFD03E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M319.885 176.804C319.885 184.042 324.967 192.844 331.236 196.463C337.503 200.081 342.585 197.149 342.585 189.911C342.585 182.673 337.503 173.87 331.236 170.251C324.967 166.632 319.885 169.567 319.885 176.804ZM322.344 178.224C322.344 172.553 326.323 170.255 331.236 173.089C336.146 175.925 340.126 182.82 340.126 188.492C340.126 194.162 336.145 196.461 331.236 193.625C326.323 190.79 322.344 183.894 322.344 178.224Z",
    fill: "#FFE54C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M325.342 172.272C323.948 173.281 323.102 175.176 323.102 177.789C323.102 183.46 327.084 190.355 331.994 193.19C334.256 194.496 336.32 194.71 337.889 194.01C336.259 195.19 333.884 195.157 331.237 193.627C326.324 190.793 322.344 183.897 322.344 178.227C322.344 175.167 323.504 173.092 325.342 172.272Z",
    fill: "url(#paint27_linear_9_151555)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M326.993 167.284C329.061 165.981 331.971 166.104 335.196 167.967C341.465 171.586 346.545 180.387 346.545 187.626C346.545 191.298 345.237 193.859 343.13 195.023H343.132L339.516 197.097C341.42 195.853 342.587 193.377 342.587 189.913C342.587 182.675 337.505 173.872 331.238 170.253C328.171 168.482 325.39 168.285 323.345 169.387L326.993 167.282V167.284Z",
    fill: "url(#paint28_linear_9_151555)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M330.474 176.552V176.028C330.168 176.041 329.873 176.139 329.62 176.31L329.628 176.288L328.896 176.707L328.908 176.718C329.14 176.577 329.401 176.488 329.672 176.46C329.943 176.431 330.217 176.462 330.474 176.552H330.474Z",
    fill: "#E19100"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M331.998 182.098C331.508 181.778 331.1 181.348 330.808 180.841C330.515 180.335 330.346 179.766 330.314 179.182C330.307 178.919 330.369 178.658 330.494 178.427C329.94 178.425 329.555 178.857 329.555 179.62C329.587 180.204 329.756 180.773 330.048 181.28C330.341 181.786 330.749 182.217 331.24 182.536C333.01 183.558 334.451 186.054 334.451 188.1C334.451 189.184 334.046 189.924 333.4 190.228L334.23 189.755V189.744C334.83 189.417 335.211 188.702 335.211 187.661C335.211 185.616 333.768 183.12 331.998 182.098Z",
    fill: "url(#paint29_linear_9_151555)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M332.002 191.57L332.762 191.131V190.371C332.506 190.387 332.249 190.358 332.002 190.285V191.57Z",
    fill: "#E19100"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M331.229 174.72L330.471 175.158L331.998 176.04L332.758 175.601L331.229 174.72Z",
    fill: "#FCBA06"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M332.762 175.602L332.003 176.041L332.002 177.432L332.762 176.993L332.762 175.602Z",
    fill: "#E19100"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M332.762 176.998L332.002 177.437C333.406 178.644 334.451 180.709 334.452 182.45L335.212 182.011C335.209 180.271 334.166 178.206 332.762 176.998Z",
    fill: "url(#paint30_linear_9_151555)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M328.785 183.951L328.026 184.39L329.554 185.272L330.313 184.833L328.785 183.951Z",
    fill: "#FCBA06"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M331.998 187.75C331.508 187.43 331.1 187 330.807 186.493C330.515 185.986 330.346 185.417 330.314 184.833L329.555 185.272C329.587 185.856 329.756 186.425 330.049 186.932C330.342 187.438 330.75 187.869 331.24 188.189C331.9 188.57 332.467 188.453 332.742 187.971C332.479 187.965 332.222 187.888 331.998 187.75Z",
    fill: "url(#paint31_linear_9_151555)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M331.239 182.536C330.748 182.217 330.34 181.786 330.047 181.28C329.755 180.773 329.586 180.205 329.554 179.62C329.554 178.546 330.309 178.112 331.239 178.647C331.729 178.967 332.136 179.398 332.429 179.905C332.721 180.412 332.89 180.98 332.922 181.564L334.45 182.447C334.449 180.706 333.404 178.641 332 177.434L332.001 176.043L330.474 175.161V176.551C329.072 176.14 328.027 176.996 328.027 178.739C328.087 179.853 328.409 180.937 328.967 181.904C329.525 182.87 330.304 183.691 331.239 184.301C331.729 184.62 332.136 185.051 332.429 185.558C332.721 186.065 332.89 186.633 332.922 187.217C332.922 188.29 332.167 188.726 331.239 188.19C330.749 187.87 330.341 187.44 330.048 186.933C329.755 186.426 329.586 185.857 329.554 185.273L328.026 184.391C328.026 186.13 329.071 188.195 330.474 189.402V190.686L332.001 191.568V190.284C333.404 190.697 334.45 189.84 334.45 188.1C334.45 186.054 333.009 183.558 331.239 182.536Z",
    fill: "#FFE54C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M265.436 178.239L233.728 159.932L265.436 141.625L297.144 159.932L265.436 178.239Z",
    fill: "#F6F6FB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M265.436 214.851L233.728 196.544V159.933L265.436 178.239V214.851Z",
    fill: "#CED3F8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M265.435 214.851L297.144 196.544V159.933L265.435 178.239V214.851Z",
    fill: "#BBC0E6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M265.436 147.76L262.901 146.296L265.436 144.833L267.972 146.296L265.436 147.76ZM271.342 151.17L268.807 149.706L271.342 148.243L273.878 149.706L271.342 151.17ZM277.249 154.579L274.712 153.116L277.249 151.651L279.782 153.116L277.249 154.579ZM283.153 157.989L280.618 156.524L283.153 155.06L285.689 156.524L283.153 157.989ZM289.059 161.398L286.523 159.934L289.059 158.471L291.594 159.934L289.059 161.398ZM259.531 151.17L256.996 149.706L259.531 148.243L262.066 149.706L259.531 151.17ZM265.436 154.579L262.901 153.116L265.436 151.651L267.972 153.116L265.436 154.579ZM271.342 157.989L268.807 156.524L271.342 155.06L273.878 156.524L271.342 157.989ZM277.249 161.398L274.712 159.934L277.249 158.471L279.782 159.934L277.249 161.398ZM283.153 164.807L280.618 163.343L283.153 161.88L285.689 163.343L283.153 164.807ZM253.627 154.579L251.091 153.116L253.627 151.651L256.163 153.116L253.627 154.579ZM259.531 157.989L256.996 156.524L259.531 155.06L262.066 156.524L259.531 157.989ZM265.436 161.398L262.901 159.934L265.436 158.471L267.972 159.934L265.436 161.398ZM271.342 164.807L268.807 163.343L271.342 161.88L273.878 163.343L271.342 164.807ZM277.249 168.216L274.712 166.753L277.249 165.289L279.782 166.753L277.249 168.216ZM247.721 157.989L245.185 156.524L247.721 155.06L250.257 156.524L247.721 157.989ZM253.627 161.398L251.091 159.934L253.627 158.471L256.163 159.934L253.627 161.398ZM259.531 164.807L256.996 163.343L259.531 161.88L262.066 163.343L259.531 164.807ZM265.436 168.216L262.901 166.753L265.436 165.289L267.972 166.753L265.436 168.216ZM271.342 171.627L268.807 170.162L271.342 168.699L273.878 170.162L271.342 171.627ZM241.815 161.398L239.28 159.934L241.815 158.471L244.351 159.934L241.815 161.398ZM247.721 164.807L245.185 163.343L247.721 161.88L250.257 163.343L247.721 164.807ZM253.627 168.216L251.091 166.753L253.627 165.289L256.163 166.753L253.627 168.216ZM259.531 171.627L256.996 170.162L259.531 168.699L262.066 170.162L259.531 171.627ZM265.436 175.036L262.901 173.573L265.436 172.108L267.972 173.573L265.436 175.036ZM239.041 169.132L236.505 167.669V164.741L239.041 166.205V169.132ZM244.945 172.541L242.411 171.078V168.15L244.945 169.614V172.541ZM250.851 175.951L248.315 174.487V171.56L250.851 173.023V175.951ZM256.756 179.361L254.221 177.896V174.97L256.756 176.434V179.361ZM262.662 182.77L260.127 181.306V178.378L262.662 179.842V182.77ZM239.041 175.951L236.505 174.487V171.56L239.041 173.023V175.951ZM244.945 179.36L242.411 177.896V174.97L244.945 176.434V179.36ZM250.851 182.77L248.315 181.306V178.378L250.851 179.842V182.77ZM256.756 186.18L254.221 184.715V181.789L256.756 183.252V186.18ZM262.662 189.589L260.127 188.126V185.197L262.662 186.662V189.589ZM239.041 182.77L236.505 181.306V178.378L239.041 179.842V182.77ZM244.945 186.18L242.411 184.715V181.789L244.945 183.252V186.18ZM250.851 189.589L248.315 188.126V185.197L250.851 186.662V189.589ZM256.756 192.999L254.221 191.534V188.608L256.756 190.072V192.999ZM262.662 196.408L260.127 194.944V192.016L262.662 193.48V196.408ZM239.041 189.589L236.505 188.126V185.197L239.041 186.662V189.589ZM244.945 192.999L242.411 191.534V188.608L244.945 190.072V192.999ZM250.851 196.408L248.315 194.944V192.016L250.851 193.48V196.408ZM256.756 199.819L254.221 198.354V195.426L256.756 196.89V199.819ZM262.662 203.227L260.127 201.763V198.835L262.662 200.299V203.227ZM239.041 196.408L236.505 194.944V192.016L239.041 193.48V196.408ZM244.945 199.819L242.411 198.354V195.426L244.945 196.89V199.819ZM250.851 203.227L248.315 201.763V198.835L250.851 200.299V203.227ZM256.756 206.636L254.221 205.173V202.244L256.756 203.709V206.636ZM262.662 210.046L260.127 208.582V205.655L262.662 207.119V210.046ZM291.834 169.132L294.369 167.669V164.741L291.834 166.205V169.132ZM285.929 172.541L288.464 171.078V168.15L285.929 169.614V172.541ZM280.023 175.951L282.558 174.487V171.56L280.023 173.023V175.951ZM274.117 179.361L276.653 177.896V174.97L274.117 176.434V179.361ZM268.212 182.77L270.748 181.306V178.378L268.212 179.842V182.77ZM291.834 175.951L294.369 174.487V171.56L291.834 173.023V175.951ZM285.929 179.36L288.464 177.896V174.97L285.929 176.434V179.36ZM280.023 182.77L282.558 181.306V178.378L280.023 179.842V182.77ZM274.117 186.18L276.653 184.715V181.789L274.117 183.252V186.18ZM268.212 189.589L270.748 188.126V185.197L268.212 186.662V189.589ZM291.834 182.77L294.369 181.306V178.378L291.834 179.842V182.77ZM285.929 186.18L288.464 184.715V181.789L285.929 183.252V186.18ZM280.023 189.589L282.558 188.126V185.197L280.023 186.662V189.589ZM274.117 192.999L276.653 191.534V188.608L274.117 190.072V192.999ZM268.212 196.408L270.748 194.944V192.016L268.212 193.48V196.408ZM291.834 189.589L294.369 188.126V185.197L291.834 186.662V189.589ZM285.929 192.999L288.464 191.534V188.608L285.929 190.072V192.999ZM280.023 196.408L282.558 194.944V192.016L280.023 193.48V196.408ZM274.117 199.819L276.653 198.354V195.426L274.117 196.89V199.819ZM268.212 203.227L270.748 201.763V198.835L268.212 200.299V203.227ZM291.834 196.408L294.369 194.944V192.016L291.834 193.48V196.408ZM285.929 199.819L288.464 198.354V195.426L285.929 196.89V199.819ZM280.023 203.227L282.558 201.763V198.835L280.023 200.299V203.227ZM274.117 206.636L276.653 205.173V202.244L274.117 203.709V206.636ZM268.212 210.046L270.748 208.582V205.655L268.212 207.119V210.046Z",
    fill: "#DAE0F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0935 112.506C53.0935 115.483 55.184 119.104 57.7628 120.593C60.3406 122.082 62.4311 120.875 62.4311 117.897C62.4311 114.92 60.3406 111.299 57.7628 109.811C55.184 108.321 53.0935 109.529 53.0935 112.506Z",
    stroke: "#FFF294",
    strokeWidth: 0.709355,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1387 115.365C48.1387 118.343 50.2295 121.964 52.8084 123.452C55.3862 124.941 57.4766 123.734 57.4766 120.757C57.4766 117.779 55.3862 114.159 52.8084 112.67C50.2295 111.181 48.1387 112.388 48.1387 115.365V115.365Z",
    stroke: "#FFE54C",
    strokeWidth: 1.06403,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1863 118.224C43.1863 121.201 45.2767 124.822 47.8556 126.311C50.4334 127.799 52.5239 126.593 52.5239 123.615C52.5239 120.638 50.4334 117.017 47.8556 115.529C45.2771 114.039 43.1863 115.247 43.1863 118.224V118.224Z",
    stroke: "#FFE950",
    strokeWidth: 1.41871,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.033 122.935C35.033 125.912 37.1238 129.533 39.7026 131.021C42.2804 132.51 44.3709 131.303 44.3709 128.326C44.3709 125.348 42.2804 121.728 39.7026 120.239C37.1238 118.75 35.033 119.958 35.033 122.935Z",
    fill: "#FFE54C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5297 118.106C40.3798 117.57 41.5769 117.62 42.9041 118.387C45.4826 119.875 47.5723 123.496 47.5723 126.473C47.5723 127.984 47.0339 129.038 46.1678 129.516H46.1685L43.1077 131.278C43.8908 130.766 44.3703 129.748 44.3703 128.323C44.3703 125.345 42.2802 121.724 39.7024 120.236C38.4405 119.507 37.2966 119.426 36.4553 119.879L39.5297 118.105V118.106Z",
    fill: "url(#paint32_linear_9_151555)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_151555",
    x1: 92.4578,
    y1: 219.13,
    x2: 211.027,
    y2: 219.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#CED3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_151555",
    x1: 142.381,
    y1: 88.8758,
    x2: 236.045,
    y2: 60.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0869FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_151555",
    x1: 176.133,
    y1: 108.999,
    x2: 199.977,
    y2: 67.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#321F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#00308D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#0997C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_151555",
    x1: 246.489,
    y1: 132.448,
    x2: 167.529,
    y2: -4.31439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#34318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#6B67E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_151555",
    x1: 149.918,
    y1: 191.214,
    x2: 189.722,
    y2: 191.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#CED2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#E9EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_151555",
    x1: 131.971,
    y1: 180.65,
    x2: 171.775,
    y2: 180.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#CED2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#E9EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_151555",
    x1: 142.239,
    y1: 179.252,
    x2: 127.567,
    y2: 179.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#3E3C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#5857C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_151555",
    x1: 128.358,
    y1: 148.267,
    x2: 145.178,
    y2: 148.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4241A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#363593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#252376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_151555",
    x1: 160.379,
    y1: 189.812,
    x2: 145.707,
    y2: 189.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34318A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#3E3C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#5857C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9_151555",
    x1: 154.011,
    y1: 154.753,
    x2: 128.787,
    y2: 154.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#252376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#373794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5455C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_151555",
    x1: 136.194,
    y1: 86.281,
    x2: 124.62,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#C2C6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_151555",
    x1: 166.193,
    y1: 108.955,
    x2: 130.496,
    y2: 89.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E4E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924,
    stopColor: "#D4D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9_151555",
    x1: 21.9078,
    y1: 239.592,
    x2: 3.94306,
    y2: 208.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9_151555",
    x1: 5.87072,
    y1: 219.303,
    x2: 39.0217,
    y2: 219.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9_151555",
    x1: 18.784,
    y1: 231.413,
    x2: 18.784,
    y2: 214.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9_151555",
    x1: 20.5325,
    y1: 220.294,
    x2: 20.5325,
    y2: 212.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9_151555",
    x1: 17.0198,
    y1: 228.823,
    x2: 17.0198,
    y2: 223.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EFA603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#E59701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9_151555",
    x1: 259.057,
    y1: 62.6528,
    x2: 241.092,
    y2: 31.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9_151555",
    x1: 243.019,
    y1: 42.3639,
    x2: 276.17,
    y2: 42.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9_151555",
    x1: 255.933,
    y1: 54.4738,
    x2: 255.933,
    y2: 37.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9_151555",
    x1: 257.681,
    y1: 43.3546,
    x2: 257.681,
    y2: 35.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9_151555",
    x1: 254.169,
    y1: 51.8831,
    x2: 254.169,
    y2: 46.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EFA603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#E59701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9_151555",
    x1: 72.9739,
    y1: 63.7815,
    x2: 60.4018,
    y2: 42.0056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9_151555",
    x1: 61.751,
    y1: 49.5862,
    x2: 84.9508,
    y2: 49.5862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9_151555",
    x1: 70.7886,
    y1: 58.0564,
    x2: 70.7886,
    y2: 46.2549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9_151555",
    x1: 72.0126,
    y1: 50.2779,
    x2: 72.0126,
    y2: 44.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9_151555",
    x1: 69.554,
    y1: 56.2438,
    x2: 69.554,
    y2: 52.6611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EFA603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#E59701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9_151555",
    x1: 334.568,
    y1: 195.953,
    x2: 321.996,
    y2: 174.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9_151555",
    x1: 323.345,
    y1: 181.758,
    x2: 346.545,
    y2: 181.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9_151555",
    x1: 332.383,
    y1: 190.228,
    x2: 332.383,
    y2: 178.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9_151555",
    x1: 333.607,
    y1: 182.45,
    x2: 333.607,
    y2: 176.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EEA503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#F8B405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9_151555",
    x1: 331.148,
    y1: 188.416,
    x2: 331.148,
    y2: 184.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EFA603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#E59701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9_151555",
    x1: 36.4553,
    y1: 124.514,
    x2: 47.5723,
    y2: 124.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBA06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F3AD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacing);
export default __webpack_public_path__ + "static/media/pacing.37696361695f8ea77e4e196d09cbbb13.svg";
export { ForwardRef as ReactComponent };